import types from './types';

const INITIAL_STATE = {
  isGetting: false,
  isSaving: false,

  result: [],
};

const eligibilityEncounterReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_ENCOUNTER_REQUEST:
      return {
        ...state,
        result: [],
        isGetting: true,
      };

    case types.GET_ENCOUNTER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isGetting: false,
      };

    case types.GET_ENCOUNTER_FAILURE:
      return {
        ...state,
        result: [],
        isGetting: false,
      };

    case types.SAVE_ENCOUNTER_REQUEST:
      return {
        ...state,
        result: [],
        isSaving: true,
      };

    case types.SAVE_ENCOUNTER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSaving: false,
      };

    case types.SAVE_ENCOUNTER_FAILURE:
      return {
        ...state,
        result: [],
        isSaving: false,
      };

    default:
      return state;
  }
};

export default eligibilityEncounterReducer;
